import RequireAuth from 'common/auth/RequireAuth';
import RequireCoordinatorOrLegalRep from 'common/auth/RequireCoordinatorOrLegalRep';
import RequireNotVetted from 'common/auth/RequireNotVetted';
import RequireOpenedCharityAccount from 'common/auth/RequireOpenedCharityAccount';
import RequirePasswordSet from 'common/auth/RequirePasswordSet';
import RequireVetted from 'common/auth/RequireVetted';
import RequireVettingInProgress from 'common/auth/RequireVettingInProgress';
import LayoutBase from 'common/layouts/base-layout/LayoutBase';
import LoginLayoutBase from 'common/layouts/base-layout/LoginLayoutBase';
import { ChangePasswordEntry } from 'features/change-password/entries';
import CharityVettingEntry from 'features/charity-vetting/common-flow/entries/CharityVettingEntry';
import { CompleteAccountEntry } from 'features/complete-account/entries';
import { DocumentTypeEntry, DocumentsEntry } from 'features/documents/entries';
import { DonationsEntry } from 'features/donations/entries';
import { HelpCenterEntry } from 'features/help-center/entries';
import { LoginEntry } from 'features/login/entries';
import { LogoutEntry } from 'features/logout/entries';
import { NotFoundEntry } from 'features/not-found/entries';
import { ResetPasswordEntry } from 'features/reset-password/entries';
import { SettingsEntry } from 'features/settings/entries';
import { SignUpEntry } from 'features/signup/entries';
import { UsersEntry } from 'features/users/entries';
import { VerificationEmailEntry } from 'features/verification-email/entries';
import { VettingProgressEntry } from 'features/vetting-progress/entries';
import { Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from 'react-router';

import AriaRouterProvider from './AriaRouterProvider';
import {
  CHANGE_PASSWORD_PATH,
  CHARITY_PATH,
  CHARITY_VETTING_PATH,
  COMPLETE_ACCOUNT_PATH,
  DONATIONS_PATH,
  DOCUMENTS_PATH,
  DOCUMENT_TYPE_PATH,
  LOGIN_PATH,
  LOGOUT_PATH,
  RESET_PASSWORD_PATH,
  SIGNUP_PATH,
  VERIFICATION_EMAIL_PATH,
  USERS_PATH,
  VETTING_PROGRESS_PATH,
  HELP_CENTER_PATH,
  SETTINGS_PATH,
} from './paths/paths';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<AriaRouterProvider />}>
      <Route
        element={
          <Suspense fallback={null}>
            <LoginLayoutBase />
          </Suspense>
        }
      >
        <Route path={LOGIN_PATH} element={<LoginEntry />} />
        <Route path={SIGNUP_PATH} element={<SignUpEntry />} />
        <Route path={COMPLETE_ACCOUNT_PATH} element={<CompleteAccountEntry />} />
        <Route path={VERIFICATION_EMAIL_PATH} element={<VerificationEmailEntry />} />
        <Route path={RESET_PASSWORD_PATH} element={<ResetPasswordEntry />} />
        <Route path={CHANGE_PASSWORD_PATH} element={<ChangePasswordEntry />} />
      </Route>

      <Route element={<RequireAuth />}>
        <Route element={<RequireOpenedCharityAccount />}>
          <Route element={<RequirePasswordSet />}>
            <Route element={<LayoutBase />}>
              <Route element={<RequireVettingInProgress />}>
                <Route path={VETTING_PROGRESS_PATH} element={<VettingProgressEntry />} />
              </Route>
              <Route path={HELP_CENTER_PATH} element={<HelpCenterEntry />} />
              <Route path={SETTINGS_PATH} element={<SettingsEntry />} />
              <Route element={<RequireVetted />}>
                <Route index path={DONATIONS_PATH} element={<DonationsEntry />} />
                {/* Admin "open in myCharity" deep link (SSO sets cookies, then redirects here). */}
                <Route path={CHARITY_PATH} element={<Navigate to={DONATIONS_PATH} replace />} />
                <Route element={<RequireCoordinatorOrLegalRep />}>
                  <Route path={USERS_PATH} element={<UsersEntry />} />
                  <Route path={DOCUMENTS_PATH} element={<DocumentsEntry />} />
                  <Route path={DOCUMENT_TYPE_PATH} element={<DocumentTypeEntry />} />
                </Route>
              </Route>
            </Route>
          </Route>
          <Route element={<RequireNotVetted />}>
            <Route path={`${CHARITY_VETTING_PATH}/*`} element={<CharityVettingEntry />} />
          </Route>
        </Route>
      </Route>
      <Route path={LOGOUT_PATH} element={<LogoutEntry />} />
      <Route path='*' element={<NotFoundEntry />} />
    </Route>,
  ),
);
